import React from 'react';
import Lottie from 'react-lottie-player';
import animationData from '../../lotties/loading-animation.json';

const LoadingScreen = ({ message }) => {
    // get current url from window
    return (
        <div className='w-full flex flex-col items-center justify-center'>
            <h1 className='text-xl text-text-primary animate-fade-in-up'>{message}</h1>
            <Lottie
                loop
                animationData={animationData}
                play
                style={{ width: 200, height: 200 }}
            />
        </div >
    );
};

export default LoadingScreen;
